module.exports = __webpack_public_path__ + "img/PrinterWarning.9e2c959f.svg";